module.exports = {
    q: (selector, context) => (context || document).querySelector(selector),
    qa: (selector, context) => Array.from((context || document).querySelectorAll(selector))
};
